export default __webpack_public_path__ + "static/media/hasanprofile.f9e2ede9.jpg";